var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_error",
    transform: "translate(8 8)",
    fill: "#e94f37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 22 C 1.831779956817627 22 -4 16.16822052001953 -4 9 C -4 1.831779956817627 1.831779956817627 -4 9 -4 C 16.16822052001953 -4 22 1.831779956817627 22 9 C 22 16.16822052001953 16.16822052001953 22 9 22 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 0 C 4.037444114685059 0 0 4.037444114685059 0 9 C 0 13.96255493164062 4.037444114685059 18 9 18 C 13.96255493164062 18 18 13.96255493164062 18 9 C 18 4.037444114685059 13.96251106262207 0 9 0 M 10.12506675720215 10.125 L 7.87511157989502 10.125 L 7.87511157989502 4.5 L 10.12506675720215 4.5 L 10.12506675720215 10.125 M 10.125 13.5 L 7.875033378601074 13.5 L 7.875033378601074 11.25003337860107 L 10.125 11.25003337860107 L 10.125 13.5 M 9 -8 C 18.37383270263672 -8 26 -0.3738327026367188 26 9 C 26 18.37383270263672 18.37383270263672 26 9 26 C -0.3738327026367188 26 -8 18.37383270263672 -8 9 C -8 -0.3738327026367188 -0.3738327026367188 -8 9 -8 Z",
    stroke: "none",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.608227cb181caabce24f132e3f35265e.svg";
export { ForwardRef as ReactComponent };